import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ApiMetaDataDTO, SupplierPreferenceRuleDTO } from 'declarations'
import { toast } from 'react-toastify'

import { client } from 'services/helpers/apiConfig'

type ApiResponseDTO = {
  code: number
  data: SupplierPreferenceRuleDTO
  api_metadata: ApiMetaDataDTO
}

const useSprReadQuery = (
  uuid: string
): UseQueryResult<SupplierPreferenceRuleDTO> => {
  return useQuery({
    queryKey: ['spr', 'read', uuid],
    queryFn: async () => {
      try {
        const res = await client.get<ApiResponseDTO>(
          `supplier_preference_rules/read/${uuid}`
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}

export { useSprReadQuery }
